// extracted by mini-css-extract-plugin
export default {"containerInfo":"Info_containerInfo__ltqs5","headerInfo":"Info_headerInfo__cn--9","bodyInfo":"Info_bodyInfo__iwVzl","link":"Info_link__vqTQM"};